import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ic-destination",
  "use": "icon-ic-destination-usage",
  "viewBox": "0 0 21 20",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 21 20\" id=\"icon-ic-destination\"><path d=\"M.5 1a1 1 0 0 1 1-1h6v7h-7V1ZM7.5 7h6v6h-6zM.5 13h7v7h-6a1 1 0 0 1-1-1v-6ZM13.5 0h6a1 1 0 0 1 1 1v6h-7V0ZM13.5 13h7v6a1 1 0 0 1-1 1h-6v-7Z\" fill=\"#000\" /><rect x=\"1.5\" y=\"1\" width=\"18\" height=\"18\" rx=\"1\" stroke=\"#000\" stroke-width=\"2\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol